module.exports = __webpack_public_path__ + "1f767153a5177fca92c346392304f1b1.svg";